// angled buttons
const redzoneButtons = document.querySelectorAll(
  ".wp-block-button.is-style-angled a"
);
redzoneButtons.forEach(function (btn) {
  let html = "<span>" + btn.innerHTML + "</span>";
  btn.innerHTML = html;
});
